define('stores/TeaserStore',['event-manager'], function(eventManager) {
    var _teaserIds = [];
    var _teaserIsFetching = false;

    var TeaserStore = {
        setTeaserIds: function (teaserIds) {
            _teaserIds.push(teaserIds);
        },
        getTeaserIds: function () {
            return _teaserIds;
        },
        setTeaserIsFetching: function (value) {
            _teaserIsFetching = value;
            if (!value) {
                eventManager.emit('fetchTeaser');
            }
        },
        getTeaserIsFetching: function () {
            return _teaserIsFetching;
        }
    }

    return TeaserStore;
})
;
